import { createContext, useState, useEffect, useContext, useMemo } from "react";

const RecentSearchesContext = createContext();

export const useRecentSearches = () => useContext(RecentSearchesContext);

export const RecentSearchesProvider = ({ children }) => {
  const [recentSearches, setRecentSearches] = useState([]);

  useEffect(() => {
    const savedRecentSearches = localStorage.getItem("recentSearches");
    if (savedRecentSearches) {
      const parsedSearches = JSON.parse(savedRecentSearches);
      const uniqueSearches = [];
      const seenUpcs = new Set();

      parsedSearches.forEach((product) => {
        if (product.upc && !seenUpcs.has(product.upc)) {
          uniqueSearches.push(product);
          seenUpcs.add(product.upc);
        }
      });

      setRecentSearches(uniqueSearches);
    }
  }, []);

  const addSearch = (product) => {
    if (product && product.upc && product.name) {
      setRecentSearches((prevSearches) => {
        const updatedSearches = [
          product,
          ...prevSearches.filter((item) => item.upc !== product.upc),
        ];
        localStorage.setItem("recentSearches", JSON.stringify(updatedSearches));
        return updatedSearches;
      });
    }
  };

  const contextValue = useMemo(
    () => ({
      recentSearches,
      setRecentSearches,
      addSearch,
    }),
    [recentSearches]
  );

  return (
    <RecentSearchesContext.Provider value={contextValue}>
      {children}
    </RecentSearchesContext.Provider>
  );
};
